import { Button, Switch } from "@mui/material";
import { loadOverallFragranceToggleState } from "store/features/analysisResultsSlice";
import { useSelector, useDispatch } from "react-redux";

const OverallFragranceToggleComponent = () => {
    const dispatch = useDispatch();
    const overallFragranceToggle = useSelector((state) => state.analysisResultsStore.overallFragranceToggle);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    const handleOverallFragranceToggleChange = () => {
        dispatch(loadOverallFragranceToggleState(!overallFragranceToggle));
    };

    return (
        <Button
            size="small"
            className="custom-btn custom-btn-outlined-2 color-blue bold-content ms-2 pb-1"
            variant="outlined"
        >
            {isUnileverFragranceHouse ? "Overall Opinion" : "Overall Fragrance"}
            <Switch
                size="small"
                checked={overallFragranceToggle}
                onChange={handleOverallFragranceToggleChange}
            />
        </Button>
    );
};

export default OverallFragranceToggleComponent;
